module.exports = __webpack_public_path__ + "static/media/customer.5d1dd229.svg";